import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectGoogleTag() {
  const GA_ID = 'AW-18158826329';
  if (typeof document === 'undefined') return;
  // 1) Async loader: <script async src="https://www.googletagmanager.com/gtag/js?id=AW-18158826329"></script>
  const loaderId = 'gtag-loader-' + GA_ID;
  if (!document.getElementById(loaderId)) {
    const loader = document.createElement('script');
    loader.id = loaderId;
    loader.async = true;
    loader.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(loader);
  }
  // 2) Inline config script — match Google's standard snippet exactly,
  // injected as a real <script> element with text content so tag
  // detection tools recognize it.
  const configId = 'gtag-config-' + GA_ID;
  if (!document.getElementById(configId)) {
    const config = document.createElement('script');
    config.id = configId;
    config.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(config);
  }
})();
render(<App data-id="element-175" />, document.getElementById('root'));